module.exports = __webpack_public_path__ + "img/arbre_4.d3aa11ab.png";